module.exports = __webpack_public_path__ + "static/pipeline-update-category_3-8a6d2811dfda3ab5a11d29a86bf161e7.png";